/**
 * Ensures a userId has the 'usr_' prefix.
 * Booking URLs use userIds without the prefix, but API endpoints require it.
 * @param userId - The userId that may or may not have the 'usr_' prefix
 * @returns The userId with the 'usr_' prefix
 */
export function ensureUserIdPrefix(userId: string): string {
  if (!userId) return userId
  return userId.startsWith('usr_') ? userId : `usr_${userId}`
}
